import { Link, Stack, TypographyOwnProps } from "@mui/material";
import React from "react";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

interface Props {
  text?: string;
  href?: string;
  color?: TypographyOwnProps["color"];
  hideArrow?: boolean;
}

/**
 * Places an url link with a forward facing arrow at the end.
 * example: This is my link ->
 * @param text The text displayed in the link
 * @param href The link to navigate to
 * @param variant The variant
 * @returns A react functional component
 */
const ArrowRightLink = ({ text, href, hideArrow,color = "primary", ...rest }: Props) => {
  return (
    <Link href={href} color={color} {...rest} variant="link">
      <Stack alignItems="center" direction="row" gap="6px">
        {text}

        {!hideArrow && <ArrowForwardIcon />}
      </Stack>
    </Link>
  );
};
export default ArrowRightLink;
